module.exports = __webpack_public_path__ + "media/logos/westlaw-logo-36c497e9.png";